<template>
    <img :src="DECareerConnectLockup" alt="Discovery Education Career Connect" />
</template>

<script>
import DECareerConnectLockup from '@/assets/logos/de_career-connect_wordmark.svg';

export default {
    name: 'DECareerConnectLogo',
    data() {
        return {
            DECareerConnectLockup,
        };
    },
};
</script>
